import 'jspdf-autotable';
import { useEffect, useRef, useState } from 'react';
import Barcode from 'react-barcode';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button } from 'antd';
import dayjs from 'dayjs';
import { fetchPartyPrintBundleOutWardById } from '../../slices/bundleoutward';
import moment from 'moment';

function PartyPrintAddBundleForOutWard() {
  const { id } = useParams();
  const printRef = useRef(null);
  const dispatch = useDispatch();
  const [bundleData, setBundleData] = useState([]);

  useEffect(() => {
    if (id) {
      dispatch(fetchPartyPrintBundleOutWardById({ id })) // Ensure API supports fetching by ID
        .then(response => {
          if (response.payload) {
            setBundleData(response.payload); // Set API response into state
          }
        });
    }
  }, [dispatch, id]);

  const printStyles = `
    @media print {
      @page {
        size: auto;
        margin: 0mm;
      }
      body {
        margin: 0;
        padding: 0;
      }
      #print-footer {
        position: fixed;
        bottom: 5px;
        right: 10px;
        font-size: 12px;
      }
      /* Hide browser's default headers and footers */
      html {
        -webkit-print-color-adjust: exact;
      }
      /* Hide elements with no-print class */
      .no-print {
        display: none !important;
      }
    }
  `;

  useEffect(() => {
    const styleEl = document.createElement('style');
    styleEl.innerHTML = printStyles;
    document.head.appendChild(styleEl);

    return () => {
      document.head.removeChild(styleEl);
    };
  }, []);

  const handlePrint = () => {
    const currentDateTime = moment().format('DD/MM/YYYY hh:mm:ss A');
    let footer = document.getElementById('print-footer');
    if (!footer) {
      footer = document.createElement('div');
      footer.id = 'print-footer';
      document.body.appendChild(footer);
    }
    footer.innerHTML = ` ${currentDateTime}`;

    window.print();
  };

  return (
    <div>
      <div
        ref={printRef}
        style={{
          padding: '20px',
          fontFamily: 'Arial, sans-serif',
          textAlign: 'center',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img src={bundleData?.workorder?.bill_to?.customer_logo || " "} style={{ width: '200px', maxHeight: '70px' }} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center', // centers the whole table+image block
              alignItems: 'flex-start',
              width: '100%',
              marginTop: '20px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div>
                <table
                  style={{
                    width: '100%',
                    fontSize: '9pt',
                    borderCollapse: 'collapse',
                  }}
                >
                  <tbody>
                    {[
                      {
                        label: 'Bundle No:',
                        value: `${bundleData.bundle_no || 'N/A'}${bundleData?.workorder?.work_order_details[0]?.customer_reference_number ? ` (${bundleData.workorder.work_order_details[0].customer_reference_number})` : ''}`

                      },
                      {
                        label: 'Date:',
                        value: bundleData.packing_date
                          ? dayjs(bundleData.packing_date).format('DD-MM-YYYY')
                          : 'N/A',
                      },
                      {
                        label: 'Profile No:',
                        value:
                          bundleData.workorder?.work_order_details?.[0]
                            ?.die_profile?.die_number || 'N/A',
                      },
                      {
                        label: 'Alloy & Temper:',
                        value: `${bundleData.workorder?.work_order_details?.[0]?.alloy
                            ?.name || 'N/A'
                          } - ${bundleData.workorder?.work_order_details?.[0]?.temper
                            ?.name || 'N/A'
                          }`,
                      },
                      {
                        label: 'Length (mm):',
                        value:
                          bundleData.workorder?.work_order_details?.[0]
                            ?.length || 'N/A',
                      },
                      {
                        label: 'Pcs:',
                        value:
                          bundleData.workorder?.work_order_details?.[0]
                            ?.pieces || 'N/A',
                      },
                      {
                        label: 'Net Wt:',
                        value:
                          bundleData.workorder?.work_order_details?.[0]
                            ?.net_weight || 'N/A',
                      },
                    ].map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            width: '120px',
                            textAlign: 'left',
                            padding: '2px 6px',
                            fontWeight: 'bold',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {item.label}
                        </td>
                        <td
                          style={{
                            textAlign: 'left',
                            padding: '2px 6px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {item.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div
                style={{
                  marginLeft: '3px',
                  display: 'flex',
                  alignItems: 'center', // vertical center inside this block
                  height: '100%',
                }}
              >
                <img
                  src={bundleData?.workorder?.work_order_details[0]?.die_profile?.die_diagram}
                  alt="logo"
                  style={{ maxWidth: '140px', height: 'auto' }}
                />
              </div>
            </div>
          </div>

          <div style={{ marginTop: '10px' }}>
            <Barcode
              value={`${bundleData.bundle_no || 'N/A'} ${bundleData.packing_date || 'N/A'}`}
              width={1.5}
              height={30}
              displayValue={false}
              margin={0}
              fontSize={10}
            />
          </div>
          <Button
            onClick={handlePrint}
            className="no-print"
            type="primary"
            style={{
              marginTop: '20px',
              fontSize: '16px',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Print
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PartyPrintAddBundleForOutWard;
